import React, { memo, useCallback, useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { Color } from '@diritto/common/style/color';
import { ArrowTailIcon } from 'icons/ArrowTailIcon';
import { tm } from 'utils/tm';
import { useMedia } from 'ui-hooks/useMediaQuery';

export const TopUp = memo(({ className, scrollThreshold = 200 }: { className?: string; scrollThreshold?: number }) => {
  const [isVisible, setIsVisible] = useState(false);
  const { isPc } = useMedia();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsVisible(scrollPosition > scrollThreshold);
    };

    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrollThreshold]);

  const handleClick = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={tm('fixed flex items-center cursor-pointer right-4 bottom-[18px] z-[10]', className)}
      onClick={handleClick}>
      <div
        className={twMerge(
          'inline-flex justify-center items-center',
          'w-11 h-11 p-2.5 bg-white rounded-[60px] outline outline-1 outline-offset-[-1px] outline-black/10',
          'pc:w-[58px] pc:h-[58px]',
        )}>
        <ArrowTailIcon size={isPc ? 30 : 24} color={Color.Gray900} />
      </div>
    </div>
  );
});

TopUp.displayName = 'TopUp';
